import {shopModule} from '../module.js';
import {storage} from '@nuskin/ns-util';

shopModule.service('nsADRType', function() {
    let NO_SELECTION = "no_selection";
    let NO_SELECTION_TYPE = {isImmediate: false, value: NO_SELECTION};
    let adrType = storage.getItem(storage.metadata.ADR_TYPE) || NO_SELECTION_TYPE;

    function getADRType() {
        return adrType;
    }

    function setADRType(type) {
        adrType = type;
        storage.setItem("adrType", adrType);
    }

    function equals(type1, type2) {
        if (!type2) {
            type2 = getADRType();
        }
        return (type1.isImmediate === type2.isImmediate && type1.value === type2.value);
    }

    return {
        NO_SELECTION: NO_SELECTION,
        NO_SELECTION_TYPE: NO_SELECTION_TYPE,
        equals: equals,
        getADRType: getADRType,
        setADRType: setADRType
    }
});